import { Injectable, Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { BlacklistProfileDirection } from "app/features/nconnect-voice/interfaces/blacklist-profile/blacklist-profile.interface";
import { TranslationKeyFinalLevel } from "translations/translation-key.type";

@Pipe({
  name: "blacklistDirection",
  standalone: false,
})
@Injectable({
  providedIn: "root",
})
export class BlacklistDirectionPipe implements PipeTransform {
  private translationPrefix: string = "admin.nconnect.pipe.blacklist_direction";

  constructor(private translateService: TranslateService) {}

  public transform(direction: BlacklistProfileDirection): string {
    const translationKey: TranslationKeyFinalLevel =
      direction === "IN" ? "inbound" : "outbound";
    return this.translateService.instant(
      `${this.translationPrefix}.${translationKey}`,
    );
  }
}
